var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_40940)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6308 0.476562C6.012 0.476562 0.630753 5.85781 0.630753 12.4766C0.630753 19.0953 6.012 24.4766 12.6308 24.4766C19.2495 24.4766 24.6308 19.0953 24.6308 12.4766C24.6308 5.85781 19.2495 0.476562 12.6308 0.476562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4339 8.43242C18.7245 8.72305 18.7245 9.20117 18.4339 9.4918L11.4026 16.523C11.2573 16.6684 11.0651 16.7434 10.8729 16.7434C10.6808 16.7434 10.4886 16.6684 10.3433 16.523L6.82763 13.0074C6.53701 12.7168 6.53701 12.2387 6.82763 11.948C7.11826 11.6574 7.59638 11.6574 7.88701 11.948L10.8729 14.934L17.3745 8.43242C17.6651 8.13711 18.1433 8.13711 18.4339 8.43242Z",
    fill: "#45B36B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_40940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.630753 0.476562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/accept-icon.c9a47893179cdb11bbe4a97461ae4bb8.svg";
export { ForwardRef as ReactComponent };